// 인카운터 배경 이미지 유틸
import ARNIE_ALLEY from '../assets/map/background/Arnie/Alley_arnie.png';
import ARNIE_ARENA from '../assets/map/background/Arnie/arena_arnie.png';
import ARNIE_ARENA2 from '../assets/map/background/Arnie/arena2_arnie.png';
import ARNIE_ARENA3 from '../assets/map/background/Arnie/arena3_arnie.png';
import ARNIE_ARENA4 from '../assets/map/background/Arnie/arena4_arnie.png';
import ARNIE_ARENA5 from '../assets/map/background/Arnie/arena5_arnie.png';
import ARNIE_BATTLE_TOWER from '../assets/map/background/Arnie/battle tower_arnie.png';
import ARNIE_BURNED_TOWER from '../assets/map/background/Arnie/BurnedTower_arnie.png';
import ARNIE_CAVE from '../assets/map/background/Arnie/Cave_arnie.png';
import ARNIE_CAVE2 from '../assets/map/background/Arnie/Cave2_arnie.png';
import ARNIE_CAVE_WATER from '../assets/map/background/Arnie/Cave Water_arnie.png';
import ARNIE_CERULEAN_CAVE from '../assets/map/background/Arnie/Cerulean Cave_arnie.png';
import ARNIE_DIVE from '../assets/map/background/Arnie/dive_arnie.png';
import ARNIE_FARM from '../assets/map/background/Arnie/Farm_arnie.png';
import ARNIE_FARM2 from '../assets/map/background/Arnie/Farm2_arnie.png';
import ARNIE_FOREST from '../assets/map/background/Arnie/forest_arnie.png';
import ARNIE_GENERIC from '../assets/map/background/Arnie/Generic1_arnie.png';
import ARNIE_GRASS from '../assets/map/background/Arnie/Grass_arnie.png';
import ARNIE_GRASS_AUTUMN from '../assets/map/background/Arnie/Grass Autumn_arnie.png';
import ARNIE_GRASS_WINTER from '../assets/map/background/Arnie/Grass Winter_arnie.png';
import ARNIE_GYM from '../assets/map/background/Arnie/Gym_arnie.png';
import ARNIE_HEADBUTT_TREE from '../assets/map/background/Arnie/Headbutt tree_arnie.png';
import ARNIE_ICE_CAVE from '../assets/map/background/Arnie/Ice Cave_arnie.png';
import ARNIE_ICE_CAVE2 from '../assets/map/background/Arnie/Ice Cave2_arnie.png';
import ARNIE_INDOOR from '../assets/map/background/Arnie/Indoor_arnie.png';
import ARNIE_MART from '../assets/map/background/Arnie/Mart_arnie.png';
import ARNIE_ROUTE_SAND from '../assets/map/background/Arnie/route sand_arnie.png';
import ARNIE_ROUTE_TOWN from '../assets/map/background/Arnie/Route town_arnie.png';
import ARNIE_SAFARI from '../assets/map/background/Arnie/Safari 240_arnie.png';
import ARNIE_SEAFLOOR from '../assets/map/background/Arnie/seafloor_arnie.png';
import ARNIE_SKY_PILLAR from '../assets/map/background/Arnie/Sky Pillar_arnie.png';
import ARNIE_SOUL_HOUSE from '../assets/map/background/Arnie/soul house_arnie.png';
import ARNIE_TOWER from '../assets/map/background/Arnie/Tower_arnie.png';
import ARNIE_TOWER_ROOF from '../assets/map/background/Arnie/tower roof indexed_arnie.png';
import ARNIE_VIRTUAL from '../assets/map/background/Arnie/Virtual_arnie.png';
import ARNIE_VOLCANO from '../assets/map/background/Arnie/Volcano_arnie.png';
import ARNIE_WHIRL_ISLANDS from '../assets/map/background/Arnie/Whirl Islands cave_arnie.png';

import BEACH from '../assets/map/background/BEACH.png';
import BEACH_2 from '../assets/map/background/BEACH 2.png';
import BEACH_NIGHT from '../assets/map/background/BEACH NIGHT.png';
import CAVE from '../assets/map/background/CAVE.png';
import CAVE_2 from '../assets/map/background/CAVE 2.png';
import CAVE_NIGHT from '../assets/map/background/CAVE NIGHT.png';
import DESERT from '../assets/map/background/DESERT.png';
import DESERT_NIGHT from '../assets/map/background/DESERT NIGHT.png';
import LAKE from '../assets/map/background/LAKE.png';
import LAKE_NIGHT from '../assets/map/background/LAKE NIGHT.png';
import MOUNTAIN from '../assets/map/background/MOUNTAIN.png';
import MOUNTAIN_2 from '../assets/map/background/MOUNTAIN 2.png';
import MOUNTAIN_NIGHT from '../assets/map/background/MOUNTAIN NIGHT.png';
import OCEAN from '../assets/map/background/OCEAN.png';
import OCEAN_NIGHT from '../assets/map/background/OCEAN NIGHT.png';
import PATH from '../assets/map/background/PATH.png';
import PATH_2 from '../assets/map/background/PATH 2.png';
import PATH_NIGHT from '../assets/map/background/PATH NIGHT.png';
import SNOW from '../assets/map/background/SNOW.png';
import SNOW_NIGHT from '../assets/map/background/SNOW NIGHT.png';
import TALL_GRASS from '../assets/map/background/TALL GRASS.png';
import TALL_GRASS_NIGHT from '../assets/map/background/TALL GRASS NIGHT.png';
import UNDERWATER from '../assets/map/background/UNDERWATER.png';

export const BACKGROUND_TYPES = [
  { key: 'BEACH',              label: '해변' },
  { key: 'CAVE',               label: '동굴' },
  { key: 'DESERT',             label: '사막' },
  { key: 'LAKE',               label: '호수' },
  { key: 'MOUNTAIN',           label: '산' },
  { key: 'OCEAN',              label: '바다' },
  { key: 'PATH',               label: '길' },
  { key: 'SNOW',               label: '설원' },
  { key: 'TALL GRASS',         label: '풀숲' },
  { key: 'UNDERWATER',         label: '수중' },
  { key: 'ARNIE_ALLEY',        label: '[A] 골목' },
  { key: 'ARNIE_ARENA',        label: '[A] 아레나' },
  { key: 'ARNIE_ARENA2',       label: '[A] 아레나2' },
  { key: 'ARNIE_ARENA3',       label: '[A] 아레나3' },
  { key: 'ARNIE_ARENA4',       label: '[A] 아레나4' },
  { key: 'ARNIE_ARENA5',       label: '[A] 아레나5' },
  { key: 'ARNIE_BATTLE_TOWER', label: '[A] 배틀타워' },
  { key: 'ARNIE_BURNED_TOWER', label: '[A] 불탄탑' },
  { key: 'ARNIE_CAVE',         label: '[A] 동굴' },
  { key: 'ARNIE_CAVE2',        label: '[A] 동굴2' },
  { key: 'ARNIE_CAVE_WATER',   label: '[A] 동굴수중' },
  { key: 'ARNIE_CERULEAN_CAVE',label: '[A] 하늘동굴' },
  { key: 'ARNIE_DIVE',         label: '[A] 다이브' },
  { key: 'ARNIE_FARM',         label: '[A] 농장' },
  { key: 'ARNIE_FARM2',        label: '[A] 농장2' },
  { key: 'ARNIE_FOREST',       label: '[A] 숲' },
  { key: 'ARNIE_GENERIC',      label: '[A] 일반' },
  { key: 'ARNIE_GRASS',        label: '[A] 풀숲' },
  { key: 'ARNIE_GRASS_AUTUMN', label: '[A] 풀숲(가을)' },
  { key: 'ARNIE_GRASS_WINTER', label: '[A] 풀숲(겨울)' },
  { key: 'ARNIE_GYM',          label: '[A] 체육관' },
  { key: 'ARNIE_HEADBUTT_TREE',label: '[A] 박치기나무' },
  { key: 'ARNIE_ICE_CAVE',     label: '[A] 얼음동굴' },
  { key: 'ARNIE_ICE_CAVE2',    label: '[A] 얼음동굴2' },
  { key: 'ARNIE_INDOOR',       label: '[A] 실내' },
  { key: 'ARNIE_MART',         label: '[A] 마트' },
  { key: 'ARNIE_ROUTE_SAND',   label: '[A] 모래길' },
  { key: 'ARNIE_ROUTE_TOWN',   label: '[A] 마을길' },
  { key: 'ARNIE_SAFARI',       label: '[A] 사파리' },
  { key: 'ARNIE_SEAFLOOR',     label: '[A] 해저' },
  { key: 'ARNIE_SKY_PILLAR',   label: '[A] 하늘의기둥' },
  { key: 'ARNIE_SOUL_HOUSE',   label: '[A] 혼의집' },
  { key: 'ARNIE_TOWER',        label: '[A] 탑' },
  { key: 'ARNIE_TOWER_ROOF',   label: '[A] 탑지붕' },
  { key: 'ARNIE_VIRTUAL',      label: '[A] 가상' },
  { key: 'ARNIE_VOLCANO',      label: '[A] 화산' },
  { key: 'ARNIE_WHIRL_ISLANDS',label: '[A] 소용돌이섬' },
];

const BG_MAP = {
  'BEACH':               { day: [BEACH, BEACH_2],           night: [BEACH_NIGHT] },
  'CAVE':                { day: [CAVE, CAVE_2],             night: [CAVE_NIGHT] },
  'DESERT':              { day: [DESERT],                   night: [DESERT_NIGHT] },
  'LAKE':                { day: [LAKE],                     night: [LAKE_NIGHT] },
  'MOUNTAIN':            { day: [MOUNTAIN, MOUNTAIN_2],     night: [MOUNTAIN_NIGHT] },
  'OCEAN':               { day: [OCEAN],                    night: [OCEAN_NIGHT] },
  'PATH':                { day: [PATH, PATH_2],             night: [PATH_NIGHT] },
  'SNOW':                { day: [SNOW],                     night: [SNOW_NIGHT] },
  'TALL GRASS':          { day: [TALL_GRASS],               night: [TALL_GRASS_NIGHT] },
  'UNDERWATER':          { day: [UNDERWATER],               night: [UNDERWATER] },
  'ARNIE_ALLEY':         { day: [ARNIE_ALLEY],         night: [ARNIE_ALLEY],         noBase: true },
  'ARNIE_ARENA':         { day: [ARNIE_ARENA],         night: [ARNIE_ARENA],         noBase: true },
  'ARNIE_ARENA2':        { day: [ARNIE_ARENA2],        night: [ARNIE_ARENA2],        noBase: true },
  'ARNIE_ARENA3':        { day: [ARNIE_ARENA3],        night: [ARNIE_ARENA3],        noBase: true },
  'ARNIE_ARENA4':        { day: [ARNIE_ARENA4],        night: [ARNIE_ARENA4],        noBase: true },
  'ARNIE_ARENA5':        { day: [ARNIE_ARENA5],        night: [ARNIE_ARENA5],        noBase: true },
  'ARNIE_BATTLE_TOWER':  { day: [ARNIE_BATTLE_TOWER],  night: [ARNIE_BATTLE_TOWER],  noBase: true },
  'ARNIE_BURNED_TOWER':  { day: [ARNIE_BURNED_TOWER],  night: [ARNIE_BURNED_TOWER],  noBase: true },
  'ARNIE_CAVE':          { day: [ARNIE_CAVE],          night: [ARNIE_CAVE],          noBase: true },
  'ARNIE_CAVE2':         { day: [ARNIE_CAVE2],         night: [ARNIE_CAVE2],         noBase: true },
  'ARNIE_CAVE_WATER':    { day: [ARNIE_CAVE_WATER],    night: [ARNIE_CAVE_WATER],    noBase: true },
  'ARNIE_CERULEAN_CAVE': { day: [ARNIE_CERULEAN_CAVE], night: [ARNIE_CERULEAN_CAVE], noBase: true },
  'ARNIE_DIVE':          { day: [ARNIE_DIVE],          night: [ARNIE_DIVE],          noBase: true },
  'ARNIE_FARM':          { day: [ARNIE_FARM],          night: [ARNIE_FARM],          noBase: true },
  'ARNIE_FARM2':         { day: [ARNIE_FARM2],         night: [ARNIE_FARM2],         noBase: true },
  'ARNIE_FOREST':        { day: [ARNIE_FOREST],        night: [ARNIE_FOREST],        noBase: true },
  'ARNIE_GENERIC':       { day: [ARNIE_GENERIC],       night: [ARNIE_GENERIC],       noBase: true },
  'ARNIE_GRASS':         { day: [ARNIE_GRASS],         night: [ARNIE_GRASS],         noBase: true },
  'ARNIE_GRASS_AUTUMN':  { day: [ARNIE_GRASS_AUTUMN],  night: [ARNIE_GRASS_AUTUMN],  noBase: true },
  'ARNIE_GRASS_WINTER':  { day: [ARNIE_GRASS_WINTER],  night: [ARNIE_GRASS_WINTER],  noBase: true },
  'ARNIE_GYM':           { day: [ARNIE_GYM],           night: [ARNIE_GYM],           noBase: true },
  'ARNIE_HEADBUTT_TREE': { day: [ARNIE_HEADBUTT_TREE], night: [ARNIE_HEADBUTT_TREE], noBase: true },
  'ARNIE_ICE_CAVE':      { day: [ARNIE_ICE_CAVE],      night: [ARNIE_ICE_CAVE],      noBase: true },
  'ARNIE_ICE_CAVE2':     { day: [ARNIE_ICE_CAVE2],     night: [ARNIE_ICE_CAVE2],     noBase: true },
  'ARNIE_INDOOR':        { day: [ARNIE_INDOOR],        night: [ARNIE_INDOOR],        noBase: true },
  'ARNIE_MART':          { day: [ARNIE_MART],          night: [ARNIE_MART],          noBase: true },
  'ARNIE_ROUTE_SAND':    { day: [ARNIE_ROUTE_SAND],    night: [ARNIE_ROUTE_SAND],    noBase: true },
  'ARNIE_ROUTE_TOWN':    { day: [ARNIE_ROUTE_TOWN],    night: [ARNIE_ROUTE_TOWN],    noBase: true },
  'ARNIE_SAFARI':        { day: [ARNIE_SAFARI],        night: [ARNIE_SAFARI],        noBase: true },
  'ARNIE_SEAFLOOR':      { day: [ARNIE_SEAFLOOR],      night: [ARNIE_SEAFLOOR],      noBase: true },
  'ARNIE_SKY_PILLAR':    { day: [ARNIE_SKY_PILLAR],    night: [ARNIE_SKY_PILLAR],    noBase: true },
  'ARNIE_SOUL_HOUSE':    { day: [ARNIE_SOUL_HOUSE],    night: [ARNIE_SOUL_HOUSE],    noBase: true },
  'ARNIE_TOWER':         { day: [ARNIE_TOWER],         night: [ARNIE_TOWER],         noBase: true },
  'ARNIE_TOWER_ROOF':    { day: [ARNIE_TOWER_ROOF],    night: [ARNIE_TOWER_ROOF],    noBase: true },
  'ARNIE_VIRTUAL':       { day: [ARNIE_VIRTUAL],       night: [ARNIE_VIRTUAL],       noBase: true },
  'ARNIE_VOLCANO':       { day: [ARNIE_VOLCANO],       night: [ARNIE_VOLCANO],       noBase: true },
  'ARNIE_WHIRL_ISLANDS': { day: [ARNIE_WHIRL_ISLANDS], night: [ARNIE_WHIRL_ISLANDS], noBase: true },
};

export function isNoBaseBackground(type) {
  return !!(type && BG_MAP[type]?.noBase);
}

export function getEncounterBackground(type) {
  if (!type || !BG_MAP[type]) return null;
  const hour = new Date().getHours();
  const isNight = hour < 6 || hour >= 18;
  const pool = isNight ? BG_MAP[type].night : BG_MAP[type].day;
  return pool[Math.floor(Math.random() * pool.length)];
}

export function getPreviewBackground(type) {
  if (!type || !BG_MAP[type]) return null;
  return BG_MAP[type].day[0];
}
